export class BatchGetAggregationRowsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchGetAggregationRowsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
